import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_train_types',
};

export const getTrainTypesRequest = (constraints?: any) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
